import React from 'react';
import { Navigate } from 'react-router-dom';

// Guards /teacher/* routes: requires a token AND a teacher-role user in session.
const ProtectedRoute = ({ children }) => {
  const accessToken = localStorage.getItem('accessToken');
  let user = null;
  try {
    user = JSON.parse(sessionStorage.getItem('user'));
  } catch {
    user = null;
  }

  if (!accessToken || !user || user.role !== 'teacher') {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
